<div class="detail-container">

  <!-- Back Nav -->
  <div class="nav-header">
    <button class="back-btn" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon> Volver al listado
    </button>
  </div>

  <div *ngIf="loading" class="loading-state">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Cargando detalle...</p>
  </div>

  <div *ngIf="error && !loading" class="error-state">
    <p>{{error}}</p>
    <button (click)="goBack()">Volver</button>
  </div>

  <!-- Main Document Card -->
  <div class="detail-card" *ngIf="detalle && !loading">

    <!-- Header -->
    <div class="card-header">
      <div class="route-info">
        <h2><mat-icon>directions_boat</mat-icon> {{detalle.vesselName}}</h2>
        <p>Viaje {{detalle.voyageNumber}} • {{detalle.carrierName}}</p>
      </div>
      <div class="header-actions">
        <button (click)="downloadPdf()">
          <mat-icon>download</mat-icon> PDF
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="card-body">

      <!-- Route Section -->
      <div class="detail-section">
        <h3><mat-icon>map</mat-icon> Información de Ruta</h3>
        <div class="info-grid">
          <div class="info-item">
            <label>Puerto Embarque (POL)</label>
            <span>{{detalle.polName}}</span>
          </div>
          <div class="info-item">
            <label>ETD Estimado</label>
            <span>{{formatDate(detalle.etd)}}</span>
          </div>
          <div class="info-item">
            <label>Puerto Descarga (POD)</label>
            <span>{{detalle.podName}}</span>
          </div>
          <div class="info-item">
            <label>ETA Estimado</label>
            <span>{{formatDate(detalle.eta)}}</span>
          </div>
          <div class="info-item">
            <label>Tiempo Tránsito</label>
            <span class="highlight">{{detalle.transitTime ? detalle.transitTime + ' días' : '-'}}</span>
          </div>
          <div class="info-item">
            <label>Fecha de Declaración</label>
            <span>{{detalle.declarationDate ? formatDate(detalle.declarationDate) : '-'}}</span>
          </div>
        </div>
      </div>

      <!-- Voyage Deadlines Section (Stacking, Cutoff, Late Arrival) -->
      <div class="detail-section"
        *ngIf="detalle.remarksStacking || detalle.documentalCutOffDate || detalle.remarksLateArrival">
        <h3><mat-icon>schedule</mat-icon> Fechas Límite del Viaje</h3>
        <div class="deadlines-box">
          <div class="deadlines-content">
            <div class="deadline-item" *ngIf="detalle.remarksStacking">
              <label>Stacking</label>
              <span>{{detalle.remarksStacking}}</span>
            </div>
            <div class="deadline-item" *ngIf="detalle.documentalCutOffDate">
              <label>Corte Documental</label>
              <span class="date-highlight">{{detalle.documentalCutOffDate}}</span>
            </div>
            <div class="deadline-item" *ngIf="detalle.remarksLateArrival">
              <label>Late Arrival</label>
              <span>{{detalle.remarksLateArrival}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-section" *ngIf="detalle.voyageCalls && detalle.voyageCalls.length > 0">
        <h3><mat-icon>linear_scale</mat-icon> Ruta del Buque</h3>
        <div class="timeline-container">
          <ul class="compact-timeline">
            <li *ngFor="let call of detalle.voyageCalls" [class.pol-node]="call.isPol" [class.pod-node]="call.isPod"
              [class.passed-node]="false"> <!-- Could add logic for passed nodes based on dates -->

              <div class="timeline-time">
                <div class="date-row" *ngIf="call.eta">
                  <span class="date-label">ETA</span>
                  <span class="date-value">{{ call.eta }}</span>
                </div>
                <div class="date-row" *ngIf="call.etd">
                  <span class="date-label">ETD</span>
                  <span class="date-value">{{ call.etd }}</span>
                </div>
              </div>

              <div class="timeline-marker"></div>

              <div class="timeline-content">
                <div class="port-header">
                  <span class="port-name">{{call.portName}}</span>

                  <!-- Badges next to name -->
                  <div class="badges" *ngIf="call.isPol || call.isPod">
                    <span class="timeline-badge error" *ngIf="call.isPol">POL</span>
                    <span class="timeline-badge success" *ngIf="call.isPod">POD</span>
                  </div>

                  <span class="country-code" *ngIf="call.countryCode"
                    [matTooltip]="call.countryName || ''">{{call.countryCode}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</div>